import { useCallback } from 'react';

import { REMOTE_FORM_STATE_KEY } from '@constants/apiConstants';
import { useEnergyContext } from '@features/Energy/Provider';
import { getInitialValues } from '@features/EnergyDetailsForm/utils';
import { useSyncState } from '@hooks/useSyncState';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';

/**
 * Hook to reset the remote user's energy details form state to its original values
 * before editing began. Resolves issues where form fields remain "stuck" for the
 * end-user if the controlling user discards changes and returns to the energy details page.
 */
const useClearRemoteEnergyFormState = () => {
  const [, setState] = useSyncState(REMOTE_FORM_STATE_KEY, {});
  const { isSyncedAppointment, hasControl } = useAppointmentContext();
  const { basketRaw } = useEnergyContext();

  const clearRemoteEnergyFormState = useCallback(() => {
    if (!isSyncedAppointment || !hasControl || !basketRaw?.energy) {
      return;
    }

    const savedValues = getInitialValues(basketRaw.energy);

    setState((prevState) => ({
      ...prevState,
      ...savedValues,
    }));
  }, [setState, isSyncedAppointment, hasControl, basketRaw?.energy]);

  return clearRemoteEnergyFormState;
};

export default useClearRemoteEnergyFormState;
